import { Link } from 'react-router-dom';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { verifyFieldNames, verifyStatus } from '@/pages/timeline/sections/timeline/timelineSections/verify/constants/index'
import { getColorCodeForTagAsPerTheme, makeFirstLetterCapsAndRemoveUnderScore } from '@/utils'
import Tag from '@/components/common/tag/tag'

import GreyTick from '@/assets/icons/greyTick.png'
import RedWarning from '@/assets/icons/redWarning.png'
import PinkWarning from '@/assets/icons/pinkWarning.png'
import GreyWarning from '@/assets/icons/greyWarning.png'
import WhiteWarning from "@/assets/icons/whiteWarning.png";

import LightGretTick from "@/assets/icons/lightGretTick.png";

import './style.css'
import { userWebsitePaths } from '@/constants/userWebsitePaths';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { themes } from '@/constants/colors_v2';

export default function VerifyView(props: any) {
    const { timeline, common } = useLocalTranslation();
    const customerCare = process.env.REACT_APP_USER_PANEL_URL + userWebsitePaths.customerCare
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);


    const rowRHSUI = (source: string) => {
        const status = props.getTheFieldStatus(source)
        // console.log(props)
        let ui = "withOutCompleteBtn"

        // verifyStatus : 
        // warn
        // incomplete: "incomplete",
        // not_submitted: "not_submitted",
        // rejected: "rejected",

        // tick
        // submitted: "submitted",
        // verified: "verified",

        // action_required: "action_required",
        // not_required: "not_required",

        if (status === verifyStatus.incomplete || status === verifyStatus.not_submitted || status === verifyStatus.rejected) {
            ui = "withCompleteBtn"
        }
        return (
            <>
                {ui === "withCompleteBtn" ? (
                    <div className='flex space-x-2 mr-[5px]'>
                        <Tag
                            text={makeFirstLetterCapsAndRemoveUnderScore(status)}
                            icon={currentTheme === themes.dark ? PinkWarning : RedWarning}
                            colorCode={getColorCodeForTagAsPerTheme(currentTheme, "red", "1")}
                            borderR_tl="5px"
                            borderR_tr="5px"
                            borderR_bl="5px"
                            borderR_br="5px"
                            borderWidth="0.5px"
                            iconWidth="15px"
                            textSize="12px"
                            line_hight="16px"
                        />
                        <button
                            // disabled={props.isSectionLocked} // testing
                            style={{
                                cursor: props.isSectionLocked ? 'not-allowed' : 'pointer'
                            }}
                            onClick={() => { props.handleRedirectToProfile(source) }}
                            className='cursor-pointer'>
                            <Tag
                                text="Complete"
                                myWidth="fit-content"
                                colorCode={getColorCodeForTagAsPerTheme(currentTheme, "grey2", "1")}
                                borderR_tl="5px"
                                borderR_tr="5px"
                                borderR_bl="5px"
                                borderR_br="5px"
                                borderWidth="0.5px"
                                iconWidth="15px"
                                textSize="14px"
                                line_hight="16px"
                            />
                        </button>
                    </div>
                ) : (
                    <div className='mr-[5px]'>
                        {source === verifyFieldNames.idVerificationStatus && !props.timelineDetails.isEligibleForCertificate ? (
                            <Tag
                                text={!props.profileVerifyStatus ? makeFirstLetterCapsAndRemoveUnderScore(verifyStatus.inelijable) : makeFirstLetterCapsAndRemoveUnderScore(status)}
                                icon={currentTheme === themes.dark ? PinkWarning : RedWarning}
                                colorCode={getColorCodeForTagAsPerTheme(currentTheme, "red", "1")}
                                borderR_tl="5px"
                                borderR_tr="5px"
                                borderR_bl="5px"
                                borderR_br="5px"
                                borderWidth="0.5px"
                                iconWidth="15px"
                                textSize="14px"
                                line_hight="16px"
                            />
                        ) : (
                            <Tag
                                text={makeFirstLetterCapsAndRemoveUnderScore(status)}
                                icon={currentTheme === themes.dark ? LightGretTick : GreyTick}
                                colorCode={getColorCodeForTagAsPerTheme(currentTheme, "grey", "1")}
                                borderR_tl="5px"
                                borderR_tr="5px"
                                borderR_bl="5px"
                                borderR_br="5px"
                                borderWidth="0.5px"
                                iconWidth="15px"
                                textSize="14px"
                                line_hight="16px"
                            />
                        )}

                    </div>
                )}
            </>
        )
    }


    const row = (verifyFieldName: string, verifyFieldText: string) => {
        // console.log(verifyFieldName, verifyFieldText)
        return (
            <div
                // style={{ background: props.actionRequiredMap[verifyFieldName] && colorCode.red.bgColor }}
                className={`commonMargin1 div1 ${props.actionRequiredMap[verifyFieldName] && 'verifySingleRowConActionReq'}`}>
                <p className="text-[15px] my500px:text-[16px] timelineSectionsCommonPaddingLeft2">{verifyFieldText}</p>
                <div>
                    {rowRHSUI(verifyFieldName)}
                </div>
            </div>
        )
    }

    return (
        <div className='verifyViewViewMain'>

            {props.timelineDetails[verifyFieldNames.basicDetailsStatus] != verifyStatus.not_required &&
                row(verifyFieldNames.basicDetailsStatus, timeline.verifySection.basicDetails)}


            {props.timelineDetails[verifyFieldNames.legalInfoStatus] != verifyStatus.not_required &&
                row(verifyFieldNames.legalInfoStatus, timeline.verifySection.legalInformation)}


            {props.timelineDetails[verifyFieldNames.addressDetailsStatus] != verifyStatus.not_required &&
                row(verifyFieldNames.addressDetailsStatus, timeline.verifySection.deliveryAddress)}


            {props.timelineDetails[verifyFieldNames.idVerificationStatus] != verifyStatus.not_required &&
                row(verifyFieldNames.idVerificationStatus, timeline.verifySection.verification)}



            {props.timelineDetails.verificationRejectionNotes != "" &&
                <div className={`flex items-center p-[18px] timelineDetailsVerificationRejectionNotesCon ml-[20px] rounded-[5px] mt-[20px] mb-[20px]`}>
                    <img className='w-[15px] h-[15px] mr-[10px]'
                        src={currentTheme === themes.dark ? WhiteWarning : GreyWarning}
                        alt='greyWarning' />
                    <div className='text-[14px]'>
                        <p className='font-medium mb-[-5px]'>{timeline.verifySection.reSubmit}</p>
                        <p>{props.timelineDetails.verificationRejectionNotes}</p>
                    </div>
                </div>
            }

            {!props.timelineDetails.isEligibleForCertificate &&
                <div className={`flex items-center justify-center p-[12px] timelineDetailsIsEligibleForCertificateCon ml-[20px] rounded-[5px] mt-[20px] mb-[20px]`}>
                    <img className='w-[15px] h-[15px] mr-[10px]'
                        src={currentTheme === themes.dark ? WhiteWarning : GreyWarning}
                        alt='greyWarning' />
                    <p className='font-medium text-[14px]'>
                        {timeline.verifySection.ineligibleText}
                        <a
                            className='ml-[5px] text-[#0173e7] underline'
                            href={customerCare}
                            target="_blank"
                            rel="noopener noreferrer">{common.statusText.contactSupport}</a>
                    </p>
                </div>
            }

            {props.timelineDetails[verifyFieldNames.bssDetailsStatus] != verifyStatus.not_required &&
                row(verifyFieldNames.bssDetailsStatus, timeline.verifySection.bss)
            }

        </div>
    );
};

